import * as S from './styled'
import { SkeletonPlaceholder } from 'src/shared/ui/skeleton/skeleton.styled'

export const GoodItemSkeletonMobile = () => {
    return (
        <S.ContainerGoodFakeMobile>
            <S.ImageBLockFakeMobile>
                <SkeletonPlaceholder />
            </S.ImageBLockFakeMobile>
            <S.ContainerContentBodyFakeMobile>
                <S.TitleFakeMobile>
                    <SkeletonPlaceholder />
                </S.TitleFakeMobile>
                <S.DescriptionFakeMobile>
                    <SkeletonPlaceholder />
                </S.DescriptionFakeMobile>
                <S.MnnFakeMobile>
                    <SkeletonPlaceholder />
                </S.MnnFakeMobile>
                <S.PriceLineFakeMobile>
                    <S.PriceStockLabelFakeMobile>
                        <SkeletonPlaceholder />
                    </S.PriceStockLabelFakeMobile>
                    <S.PriceFakeMobile>
                        <SkeletonPlaceholder />
                    </S.PriceFakeMobile>
                </S.PriceLineFakeMobile>
                <S.PriceLineFakeMobile>
                    <S.PriceDeliveryLabelFakeMobile>
                        <SkeletonPlaceholder />
                    </S.PriceDeliveryLabelFakeMobile>
                    <S.PriceFakeMobile>
                        <SkeletonPlaceholder />
                    </S.PriceFakeMobile>
                </S.PriceLineFakeMobile>
                <S.BasketChangerLineFakeMobile>
                    <S.LikeFakeMobile>
                        <SkeletonPlaceholder />
                    </S.LikeFakeMobile>
                    <S.ButtonBasketFakeMobile>
                        <SkeletonPlaceholder />
                    </S.ButtonBasketFakeMobile>
                </S.BasketChangerLineFakeMobile>
            </S.ContainerContentBodyFakeMobile>
        </S.ContainerGoodFakeMobile>
    )
}
